export const identifyUser = (
  userId: number | null | undefined,
  featureFlags: string[] | null,
) => {
  const features = Object.fromEntries(
    (featureFlags || []).map((name): [string, boolean] => [name, true]),
  )

  analytics.identify(userId == null ? undefined : String(userId), { features })
}
